import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-simulator-details',
  templateUrl: './simulator-details.component.html',
  styleUrls: ['./simulator-details.component.css'],
})
export class SimulatorDetailsComponent implements OnChanges {
  @Input() public allianceName: string;
  @Input() public isWallet: boolean = false;

  public allianceImage: string;
  private allianceImgUrl: string;

  constructor() {
    this.allianceImgUrl = `${environment.myCreditsResourcesUrl}img/alianzas/`;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['allianceName']) {
      this.allianceImage = `${this.allianceImgUrl}${this.allianceName}.png`;
    }
  }
}
